import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=23da188d&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
import style0 from "./SearchFilterTokens.vue?vue&type=style&index=0&id=23da188d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23da188d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('23da188d')) {
      api.createRecord('23da188d', component.options)
    } else {
      api.reload('23da188d', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=23da188d&scoped=true&", function () {
      api.rerender('23da188d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2ZJivm9L9rg0E/JS/comp/SearchFilterTokens.vue"
export default component.exports